<template>
    <div v-bind:class="{'d-none': !showItem}" class="row" style="margin-top: 10px;">
        <div class="col-12">
            <div class="form-group" style="width: 100%;">
                <label :for="item.key">{{ item.label }}</label>
                <input :id="item.key" :name="item.key" :placeholder="item.label" type="datetime-local" v-model="itemValue" class="form-control" autocomplete="off">
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../../../../EventBus'

    export default {
        props: [
            'item',
            'restaurant'
        ],

        data () {
            return {
                itemValue: null,
                showItem: true,
            }
        },

        created() {
            var _this = this;
            EventBus.$on('serviceTypeFormValueUpdated', (data) => {
                if (data.key == 'is_programmed') {
                    if (data.value == 'Adesso' || data.value == 'adesso') {
                        _this.showItem = false;
                    } else {
                        _this.showItem = true;
                    }
                }
            });
        },

        watch: {
            itemValue: function(newValue, oldValue) {
                EventBus.$emit('serviceTypeFormValueUpdated', {
                    key: this.item.key,
                    value: this.itemValue
                });
            }
        },
    }
</script>
